module.exports = App.ReportFilterMixin = Ember.Mixin.create
  classNames: [ 'report-filter' ]
  classNameBindings: ['typeClass']

  typeClass: Ember.computed(
    'filter.control_type',
    ->
      control_type = @get('filter.control_type')

      return null if Ember.isEmpty(control_type)

      "#{control_type.dasherize()}-report-filter"
  )

  saveFilterObserver: Ember.observer(
    'filter.value',
    'filter.valueFrom',
    'filter.valueTo',
    ->
      @send('saveFilter')
  )

  actions:
    removeFilter: ->
      @sendAction('removeFilter', @get('filter'))

    saveFilter: ->
      filter = @get('filter')

      return unless filter

      filter.save().catch (filter) ->
        filter.rollback()

      false
